module.exports = __webpack_public_path__ + "static/media/ivy-narrow.8aeb2ed6.png";